import React from 'react';
import { useParams } from 'react-router-dom';
import { DxContainer, DxCard, DxList } from '@dvag/design-system-react';

import { useGetHouseholdDashboard } from 'hooks/useGetHouseholdDashboard';
import { hasApprovedConsent } from 'utils/util';
import { showMessage } from '@dvag/dfs-orchestrator-client/messengers';

import { NotificationErrorData } from 'utils/notification/types';
import { useGetFavoritesWithAction } from 'hooks/useGetFavoritesWithAction';
import { getUpperList } from './getUpperList';
import { Item } from './Item';

import './style.css';

export const UpperList = ({ personId }: { personId: string | undefined }) => {
  const { householdId, selectedPersonId } = useParams();
  const householdDashboard = useGetHouseholdDashboard();
  const hasHousehold = !!householdId;
  const disabledClass = !hasHousehold ? 'disabled-container' : '';

  const hasAtLeastOneConsent = !!householdDashboard.data?.consentList?.find((consent) =>
    hasApprovedConsent(consent.status),
  );

  const { pageAction } = useGetFavoritesWithAction(householdId);

  const upperList = getUpperList({
    householdId,
    personId,
    hasAtLeastOneConsent,
    pageAction,
    showPlanning: true,
    showShoppingCart: true,
    showBankConnection: false,
    showAnalysisEvaluation: true,
    showCoachReport: true,
    showAlert: (data?: NotificationErrorData) =>
      showMessage(data?.title ?? '', data?.description ?? '', 'error', 'modal'),
    isHouseholdDataFetched: householdDashboard.isFetched,
  });

  return (
    <DxContainer
      color="transparent"
      className={`${disabledClass && !selectedPersonId ? 'dashboard-item-container-wr' : ''}`}
      data-testid="upper-list-container"
    >
      <DxCard color="transparent">
        <DxList>
          {upperList.map(
            ({ title, subtitle, image, chevronIcon, onClick, id, display, linkList }) => (
              <Item
                disabledClassName={disabledClass}
                key={id}
                id={id}
                title={title}
                subtitle={subtitle}
                image={image}
                chevronIcon={chevronIcon}
                onClick={onClick}
                display={display}
                linkList={linkList}
                hasHousehold={hasHousehold}
              />
            ),
          )}
        </DxList>
      </DxCard>
    </DxContainer>
  );
};
